import React from "react";
import { Picker } from "@design-system/Picker/Picker.lib";
import { Form1099ReviewFilterMode } from "./form1099ReviewFilters";

interface Props {
    value: Form1099ReviewFilterMode;
    onValueChange: (mode: Form1099ReviewFilterMode | null) => void;
    disabled?: boolean;
}

const REVIEW_MODE_OPTIONS: Array<{
    value: Form1099ReviewFilterMode;
    label: string;
}> = [
    { value: "all", label: "All" },
    { value: "suggested", label: "Suggested" },
    { value: "unreviewed", label: "To review" },
    { value: "reviewed", label: "Reviewed" },
];

/**
 * Sticky All / Suggested / To review / Reviewed select shared between the live FORM_1099
 * task body and the close template preview so the option values/labels stay in
 * sync.
 */
export const Form1099ReviewModeToggle: React.FC<Props> = ({
    value,
    onValueChange,
    disabled,
}) => (
    <Picker.Select
        items={REVIEW_MODE_OPTIONS}
        value={value}
        onValueChange={onValueChange}
        disabled={disabled}
    />
);
